import "core-js/modules/es.array.push.js";
import { inject, computed } from "vue";
import { mapMutations, mapActions } from "vuex";
import axios from "axios";
import emitter from "@/store/eventBus.js";
export default {
  data() {
    return {};
  },
  components: {},
  props: {
    totalPrice: Number
  },
  methods: {
    ...mapMutations({
      setOrderNumber: "order/setOrderNumber"
    }),
    repeatOrder() {
      this.setOrderNumber(this.historyOrder);
      this.$router.push({
        path: "/rol-shop/order",
        query: {
          repeat: this.historyOrder
        }
      });
      this.closeDrawer();
    }
    // eventOrder() {
    //   // отправка события
    //   emitter.emit("is-order-fetching");
    // },
  },
  setup() {
    const {
      cart,
      closeDrawer,
      historyOrder
    } = inject("cart");
    return {
      cart,
      closeDrawer,
      historyOrder
    };
  }
};